<template>
  <div id="orderingNotifs-page" style="padding-bottom: 2rem;">
    <h1 class="title is-2">{{ $t('Orders.deliveryMethods') }}</h1>
    <div v-for="(option, i) in place.ordering.delivery.options" :key='i' v-add-class-hover="'hovered'" class="card"
      style="border-radius: 12px;max-width:800px;cursor:pointer;">

      <div class="card-content">
        <div class="columns is-mobile">
          <div class="column is-narrow">
            <CIcon v-if="option.type=='pickup'" :height="48" name="cil-location-pin" style="color: #19aa68;" />
            <CIcon v-else :height="48" name="cil-truck" style="color: #19aa68;" />

          </div>
          <div class="column is-narrow-desktop is-6-mobile" style="max-width: 45%;" @click="$router.push('/delivery_option/'+i).catch(err => {})">
            <div class="block">
              <div class="field mt-2">
                <h1 class="title is-4" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                @click="$router.push('/delivery_option/'+i).catch(err => {})"
                >{{option.name}}</h1>

                <p v-if="option.type=='paid_delivery'" style="margin-top: -10px;">{{option.cost}} {{place.currency}}</p>
              </div>
            </div>
          </div>
          <div class="column is-hidden-mobile" style="display:inherit">
            <CLink :to="'/delivery_option/'+i" class="edit-link" style="margin-top: 12px;color:gray;">
              {{ $t('Orders.edit') }}
            </CLink>

          </div>
          <div class="column" style="text-align: right;">
            <b-switch v-model="option.active" :value="option.active" @input="saveInfo()" 
              type="is-success">
            </b-switch>
          </div>
          <div class="column is-1" style="text-align: right;">
            <CButtonClose v-if="place.ordering.delivery.options.length > 1" @click="removeDeliveryOption(i)" />
          </div>
        </div>

      </div>
    </div>

    <b-button @click="addDeliveryOption()" type="is-success">
      {{ $t('Orders.addDeliveryOption') }}
    </b-button>
  </div>

</template>

<script>
        
import _ from "underscore";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "OrderingNotifs",
  components: {
   
  },
  props: [],
  computed: _.extend(
    {
      
    },
    mapGetters({
    place: "getPlaceInfo"
  })
  ),

  data() {
    return {}
  },
  
  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    saveInfo() {
      this.place.canPublish = "true"
      this.updatePlaceInfo(this.place)
      this.$forceUpdate();
    },
    addDeliveryOption() {
      this.$ma.trackEvent({category: 'event', action: 'Delivery option added', label : null, value : null})
      let newOption = {
        type: "free_delivery",
        cost: 0,
        minAmt: 0,
        active: true,
        name: this.$t('Orders.delivery')
      }
      this.place.ordering.delivery.options.push(newOption)
      this.saveInfo();
    },
    removeDeliveryOption(i) {
      this.$ma.trackEvent({category: 'event', action: 'Delivery option removed', label : null, value : null})
      this.place.ordering.delivery.options.splice(i, 1);
      this.saveInfo();
    }
    },
    ),
  mounted() {
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
  },
  created() {
    let needToSave = false
    if (!this.place.ordering) { 
      this.place.ordering = {}
      needToSave = true 
      }
    if (!this.place.ordering.delivery) { 
      this.place.ordering.delivery = {}
      needToSave = true 
      }
    if (!this.place.ordering.delivery.options) { 
      this.place.ordering.delivery.options = []
      needToSave = true 
    }
    if (needToSave) this.saveInfo();
  }
};
</script>
